import { api } from "."

export default async function createPipedriveDeal(payload) {
	const url = "pipedrive/salusion/lead"
	await api.post({ url, data: payload })
}
